// Function for Variant Picker Description
document.addEventListener('variant:change', function (event) {
    const selectedVariantIdentifier = event.detail.variant.sku;
    const allVariantDescriptions = document.querySelectorAll('.variant__description');
    allVariantDescriptions.forEach((description) => {
        description.style.display = 'none';
    });
    const selectedVariantDescription = document.querySelector(`.variant__description.variant-${selectedVariantIdentifier}`);
    if (selectedVariantDescription) {
    selectedVariantDescription.style.display = 'block';
    }
});

  // Function for add URL name in class
    var currentPath = window.location.pathname;
    var lastPart = currentPath.substr(currentPath.lastIndexOf('/') + 1);
    document.body.classList.add(lastPart);

    document.addEventListener('DOMContentLoaded', function() {
    var areas = document.getElementsByTagName('area');
    var tooltip = document.querySelector('.tooltip');
    var tooltipTimeout;

    for (var i = 0; i < areas.length; i++) {
        areas[i].addEventListener('mouseover', function(e) {
        var areaTitle = this.getAttribute('data-title');
        clearTimeout(tooltipTimeout);
        tooltipTimeout = setTimeout(function() {
            showTooltip(e.clientX, e.clientY, areaTitle);
            highlightArea(this);
        }, 300); // Adjust the delay in milliseconds (e.g., 300 milliseconds)
        });

        areas[i].addEventListener('mouseout', function() {
        clearTimeout(tooltipTimeout);
        hideTooltip();
        removeHighlight(this);
        });
    }
    });

    function showTooltip(x, y, text) {
    var tooltip = document.querySelector('.tooltip');
    tooltip.innerText = text;
    tooltip.style.top = y + 'px';
    tooltip.style.left = x + 'px';
    tooltip.style.display = 'block';
    }
    function hideTooltip() {
        var tooltip = document.querySelector('.tooltip');
        tooltip.style.display = 'none';
    }
    function highlightArea(area) {
        area.classList.add('highlight');
    }
    function removeHighlight(area) {
        area.classList.remove('highlight');
    }

    // document.addEventListener('DOMContentLoaded', function () {
    //     function hidePrice() {
    //         var productPriceElement = document.querySelector('.product__price span');
            
    //         if (productPriceElement) {
    //             var productPriceText = productPriceElement.textContent.trim();
    //             var productPrice = parseFloat(productPriceText.replace(/[^\d.]/g, ''));

    //             if (productPrice === 0) {
    //                 var productPriceContainer = document.querySelector('.product-block--price');
    //                 if (productPriceContainer) {
    //                     productPriceContainer.style.display = 'none';
    //                 }
    //             }
    //         }
    //     }

    //     hidePrice();

    //     var observer = new MutationObserver(hidePrice);
    //     observer.observe(document.body, { childList: true, subtree: true });
    // });

    $(document).ready(function() {
        let inCartEvent,outCartEvent;
        var $ = jQuery.noConflict();
        var contactUsLink = "https://universalstatues-us.com/pages/contact";

        addToCartHider()

        let quickModal = document.querySelectorAll(".quick-product__btn")

        quickModal.forEach(function(button, index){
            button.addEventListener("click", function(event){
                event.preventDefault()

                setTimeout(() => {
                    addToCartHider()
                }, 500);
            })
        })

        $(".product-single__variants").on("change", function(event){
            event.preventDefault()

            let selectedVariant = $('.product-single__variants option:selected')

            if(!selectedVariant.length){
                customCartHider()
            }else{
                customCartShower()
            }
        })

        function addToCartHider(){
            // Check if the product is sold out
            if ($('.product-single__variants option:disabled').length == $('.product-single__variants').length || price() <= 0) {
                customCartHider()
            }else{
                let selectedVariant = $('.variant-input input:checked')

                if(selectedVariant.hasClass("disabled")){
                    customCartHider()
                }else{
                    customCartShower()
                }
            }
        }

        function customCartHider(){
            // Product is sold out, update the button
            $('.add-to-cart').html('<a href="#" id="contactUsBtn">Contact Us</a>');
            $('.product-single__form').attr('action', contactUsLink); // Update form action
            $('.product-single__form button[type="submit"]').removeAttr('disabled'); // Enable the button

            // Hide additional elements when the product is sold out
            $('.shopify-payment-button, .shopify-payment-terms, [data-section-type="store-availability"], .product__quantity, .store-availability, [data-store-availability-holder]').hide();

            // Add a click event for the "Contact Us" button
            inCartEvent = $('#contactUsBtn').on('click', function(e) {
                e.preventDefault();
                openContactForm();
            });

            outCartEvent = $('.add-to-cart').on('click', function(e) {
                e.preventDefault();
                openContactForm();
            });
        }

        function customCartShower(){
            // Product is sold out, update the button
            $('.add-to-cart').html('<span data-add-to-cart-text="" data-default-text="Add to cart">Add to cart</span>');
            $('.product-single__form button[type="submit"]').removeAttr('disabled'); // Enable the button

            // Hide additional elements when the product is sold out
            $('.shopify-payment-button, .shopify-payment-terms, [data-section-type="store-availability"], .product__quantity, .store-availability, [data-store-availability-holder]').show();
        
            if(inCartEvent){
                inCartEvent.off()
            }

            if(outCartEvent){
                outCartEvent.off()
            }
        }

        function price(){
            var priceElement = $('.product__price span').eq($('.product__price span').length - 1); // Example selector; update as needed
            // Extract the price text
            var priceText = priceElement.text().trim();
    
            // Optionally, you might want to remove currency symbols or other characters
            // For example, if the price includes a currency symbol, you can use regex to remove it
            var numericPrice = priceText.replace(/[^\d.]/g, ''); // Removes anything that's not a digit or dot

            return numericPrice
        }
    });

    function openContactForm() {
        // Create a Bootstrap modal for the contact form
        var modalContent = `
            <div class="modal-overlay"></div>
            <div class="modal" tabindex="-1" role="dialog" id="contactModal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Contact Us</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <form id="contactForm">
                                <!-- Product details -->
                                <div class="form-group">
                                    <label for="productName">Product Name:</label>
                                    <input type="text" id="productName" class="form-control" readonly>
                                </div>
                                <div class="form-group">
                                    <label for="productSKU">Product SKU:</label>
                                    <input type="text" id="productSKU" class="form-control" readonly>
                                </div>
                                <!-- Product image -->
                                <div class="form-group">
                                    <label for="productImage">Product Image:</label>
                                    <img src="" alt="Product Image" class="form-control" id="productImage" style="max-width: 100%; max-height: 300px; object-fit: contain;">
                                </div>

                                <!-- User details -->
                                <div class="form-group">
                                    <label for="name">Name <span class="required">*</span>:</label>
                                    <input type="text" id="name" class="form-control" required>
                                </div>
                                <div class="form-group">
                                    <label for="companyName">Company Name:</label>
                                    <input type="text" id="companyName" class="form-control">
                                </div>
                                <div class="form-group">
                                    <label for="email">Email <span class="required">*</span>:</label>
                                    <input type="email" id="email" class="form-control" required>
                                </div>
                                <div class="form-group">
                                    <label for="companyWebsite">Company Website:</label>
                                    <input type="text" id="companyWebsite" class="form-control">
                                </div>
                                <div class="form-group">
                                    <label for="message">Message <span class="required">*</span>:</label>
                                    <textarea id="message" class="form-control" required></textarea>
                                </div>

                                <button type="submit" class="btn btn-primary">Submit</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        `;

        // Display the modal with the form and overlay
        jQuery('body').append(modalContent);

        // Populate product details
        jQuery('#productName').val(jQuery('.product-single__title').text());

        // Use a more specific selector for SKU
        jQuery('#productSKU').val(jQuery('.product-single__sku [data-sku-id]:first').text());

        // Get the product image source
        var productImageSrc = jQuery('.product__main-photos .product-image-main img').attr('src');

        // Set the product image source in the modal
        jQuery('#productImage').attr('src', productImageSrc);

        // Initialize the modal and show it
        jQuery('#contactModal').modal('show');

        // Add a submit event for the form
        jQuery('#contactForm').on('submit', function (e) {
            e.preventDefault();
            // Get form data
            var formData = {
                productName: jQuery('#productName').val(),
                productSKU: jQuery('#productSKU').val(),
                name: jQuery('#name').val(),
                companyName: jQuery('#companyName').val(),
                email: jQuery('#email').val(),
                companyWebsite: jQuery('#companyWebsite').val(),
                message: jQuery('#message').val()
            };

            // Send the email using EmailJS
            sendEmail(formData);
        });

        // Function to send an email using EmailJS
        function sendEmail(formData) {
            // Set your EmailJS parameters
            var emailJSParams = {
                service_id: 'service_yepnd35',
                template_id: 'template_xxrp4yd',
                user_id: '4jJadAkwLeOIkYf6L' // Replace with your EmailJS Public Key
            };

            // Combine the form data with EmailJS parameters
            var combinedData = { ...emailJSParams, ...formData };

            // Use the EmailJS SDK to send the email
            emailjs.send('default_service', 'template_xxrp4yd', combinedData)
                .then(function(response) {
                    // Success handling
                    console.log('Email sent successfully:', response);

                    // Display success message in the modal
                    jQuery('#contactForm').html('<p class="text-success">Message sent successfully!</p>');
                })
                .catch(function(error) {
                    // Error handling
                    console.error('Error sending email:', error);

                    // Display error message in the modal
                    jQuery('#contactForm').html('<p class="text-danger">Error sending message. Please try again later.</p>');
                });
        }
    }

    // document.addEventListener('DOMContentLoaded', function() {
    //     // Select the "Add to Cart" button using its class
    //     var addToCartButton = document.querySelector('.text-link.quick-add-btn.js-quick-add-form.js-modal-open-quick-add');
        
    //     if (addToCartButton) {
    //         // Hide the button by setting its display property to 'none'
    //         addToCartButton.style.display = 'none';
    //     }
    // });

    document.addEventListener('DOMContentLoaded', function() {
        // Select all elements with the class 'grid-item'
        var itemQuery = document.querySelectorAll('.grid-item.grid-product');

        if (itemQuery.length > 0) {
            itemQuery.forEach(function(item, index) {
                // Find the nearest .grid-product__price--current relative to the current item
                // Assuming .grid-product__price--current is within the same ancestor context

                var priceElement = item.querySelector('.grid-item__link').querySelectorAll('.grid-product__price--current span');

                if(priceFetcher(priceElement) <= 0){
                    let gridItem = item.querySelector('.grid-product__actions').querySelector('.text-link.quick-add-btn.js-quick-add-form.js-modal-open-quick-add')
                    if(gridItem){
                        gridItem.style.setProperty('display', 'none', 'important');
                    }else{
                        let gridItem = item.querySelector('.grid-product__actions').querySelector('.text-link.quick-add-btn.js-quick-add-btn')

                        if(gridItem){
                            gridItem.style.setProperty('display', 'none', 'important');
                        }
                    }
                }
            });
        }

        function priceFetcher(element) {
            var priceElement = $(element).eq(1);
            var priceText = priceElement.text().trim();

            // Remove currency symbols and commas, but keep periods
            var numericPrice = priceText.replace(/[^0-9.,]/g, '');

            // Convert to a number considering locale (e.g., handle commas as thousands separators)
            numericPrice = numericPrice.replace(/,/g, ''); // Remove thousands separators
            var finalPrice = parseFloat(numericPrice);

            return finalPrice;
        }
    });
